import styled from "styled-components";
import Card from "../../../components/custom/Card";

export default function ImageCard ({
    src,
    index,
    viewPhoto
}: {
    src: string;
    index: number;
    viewPhoto: (index: number) => void;
}) {
    return (
        <Container>
            <Image src={src} onClick={() => viewPhoto(index)} />
        </Container>
    );
}

const Container = styled.div`
    /* border-radius: 15px;
    border: 1px solid red; */
`;

const Image = styled.img`
    height: 300px;
    width: auto;
    border-radius: 15px;
`;

